import React, { useCallback, useState } from 'react';
import cn from 'classnames/bind';
import styles from './styles.styl';
import { Text } from '@consta/uikit/Text';
import { IconDraggable } from '@consta/uikit/IconDraggable';
import { IUserInit } from 'src/redux/features/userInit/types';
import { DroppableUserEnum } from 'src/utils/enum';
import { allRole } from 'src/utils/config';
import { Checkbox } from '@consta/uikit/Checkbox';
import { Button } from '@consta/uikit/Button';
import {
  DragDropContext,
  DropResult,
  Droppable,
  Draggable,
} from 'react-beautiful-dnd';
import { AllModelType } from 'src/utils/type';
import CustomTextTooltip from '../CustomTextTooltip';
import { Theme } from '@consta/uikit/Theme';
import { myPreset } from 'src/utils/myPreset';
import { useMediaQuery } from 'react-responsive';

const cx = cn.bind(styles);

export interface IDragAccessModalProps {
  userInit: IUserInit;
  allModels: AllModelType[];
  setAllModels: React.Dispatch<React.SetStateAction<AllModelType[]>>;
  userModelData: AllModelType[];
  setAvailableModels: React.Dispatch<React.SetStateAction<AllModelType[]>>;
}

export interface ItemChecked {
  [id: string]: AllModelType;
}

const DragAccessModal: React.FC<IDragAccessModalProps> = ({
  userInit,
  allModels,
  userModelData,
  setAvailableModels,
  setAllModels,
}) => {
  const isMobile = useMediaQuery({ maxWidth: 460 });

  const newInit = [...userInit.roles];
  newInit.unshift(allRole);

  const [checkedAllUser, setCheckedAllUser] = useState<ItemChecked>({});
  const [checkedUserModel, setCheckedUserModel] = useState<ItemChecked>({});

  const handleCheckedAllUser = useCallback(
    (data) => {
      if (checkedAllUser[data.id]) {
        const newChecked = { ...checkedAllUser };
        delete newChecked[data.id];
        setCheckedAllUser(newChecked);
      } else {
        setCheckedAllUser({ ...checkedAllUser, [data.id]: data });
        setCheckedUserModel({});
      }
    },
    [checkedAllUser],
  );

  const handleCheckedUserModel = useCallback(
    (data) => {
      if (checkedUserModel[data.id]) {
        const newChecked = { ...checkedUserModel };
        delete newChecked[data.id];
        setCheckedUserModel(newChecked);
      } else {
        setCheckedUserModel({ ...checkedUserModel, [data.id]: data });
        setCheckedAllUser({});
      }
    },
    [checkedUserModel],
  );

  const handleAccess = useCallback(
    (isAllUser: boolean) => {
      if (isAllUser) {
        const newIdValue = Object.values(checkedAllUser);
        setAllModels((prev) =>
          prev.filter((item) => !newIdValue.includes(item)),
        );
        setAvailableModels([...userModelData, ...newIdValue]);
        setCheckedAllUser({});
      } else {
        const newIdValue = Object.values(checkedUserModel);
        setAvailableModels((prev: AllModelType[]) =>
          prev.filter((item: AllModelType) => !newIdValue.includes(item)),
        );
        setAllModels([...allModels, ...newIdValue]);
        setCheckedUserModel({});
      }
    },
    [
      allModels,
      checkedAllUser,
      checkedUserModel,
      setAllModels,
      setAvailableModels,
      userModelData,
    ],
  );

  const onDragEnd = (result: DropResult) => {
    const { destination, source, draggableId } = result;

    if (!destination || destination.droppableId === source.droppableId) {
      return;
    }

    const newAllUser = [...allModels];
    const newUserModelData = [...userModelData];
    const newIndexAllUser = newAllUser.findIndex(
      (item) => item.id === draggableId,
    );
    let add;
    if (source.droppableId === DroppableUserEnum.MODELS_USER) {
      add = newUserModelData[source.index];
      newUserModelData.splice(source.index, 1);
      const newChecked = { ...checkedUserModel };
      delete newChecked[draggableId];
      setCheckedUserModel(newChecked);
    } else {
      add = newAllUser[newIndexAllUser];
      newAllUser.splice(newIndexAllUser, 1);
      const newChecked = { ...checkedAllUser };
      delete newChecked[draggableId];
      setCheckedAllUser(newChecked);
    }

    if (destination.droppableId === DroppableUserEnum.MODELS_USER) {
      newUserModelData.splice(destination.index, 0, add);
    } else {
      newAllUser.splice(destination.index, 0, add);
    }

    setAllModels(newAllUser);
    setAvailableModels(newUserModelData);
  };
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div className={cx('DragAccessModal')}>
        {(Object.keys(checkedAllUser).length > 0 ||
          Object.keys(checkedUserModel).length > 0) && (
          <div className={cx('DragAccessModal__choseContent')}>
            <Text size="s" className={cx('DragAccessModal__chose')}>
              Выбрано моделей:
            </Text>
            <Text size="s" className={cx('DragAccessModal__choseNumber')}>
              {Object.keys(checkedAllUser).length > 0
                ? Object.keys(checkedAllUser).length
                : Object.keys(checkedUserModel).length}
            </Text>
            <Button
              label={
                Object.keys(checkedAllUser).length > 0
                  ? 'Разрешить доступ'
                  : 'Запретить доступ'
              }
              size={'s'}
              view="ghost"
              onClick={() =>
                handleAccess(Object.keys(checkedAllUser).length > 0)
              }
            />
          </div>
        )}
        {!isMobile && (
          <div className={cx('DragAccessModal__contentGrid')}>
            <div className={cx('DragAccessModal__titleDiv')}>
              <Text
                size="s"
                view="secondary"
                className={cx('DragAccessModal__title')}
              >
                Доступные модели
              </Text>
            </div>
            <div className={cx('DragAccessModal__titleDivAll')}>
              <Text
                size="s"
                view="secondary"
                className={cx('DragAccessModal__title')}
              >
                Все модели
              </Text>
            </div>
          </div>
        )}
        <div className={cx('DragAccessModal__contentGrid')}>
          <Droppable droppableId={DroppableUserEnum.MODELS_USER}>
            {(provided) => (
              <div className={cx('DragAccessModal__columnMobile')}>
                {isMobile && (
                  <div className={cx('DragAccessModal__titleDiv')}>
                    <Text
                      size="s"
                      view="secondary"
                      className={cx('DragAccessModal__title')}
                    >
                      Доступные модели
                    </Text>
                  </div>
                )}
                <div
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  className={cx('DragAccessModal__providContainer')}
                >
                  {userModelData.map((item, index) => (
                    <Draggable
                      key={item.id}
                      draggableId={item.id}
                      index={index}
                    >
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                        >
                          <div className={cx('DragAccessModal__containerUser')}>
                            <IconDraggable
                              className={cx('DragAccessModal__draggableIcon')}
                              {...provided.dragHandleProps}
                            />
                            <Checkbox
                              className={cx('DragAccessModal__checkbox')}
                              view="primary"
                              onClick={() => handleCheckedUserModel(item)}
                              checked={!!checkedUserModel[item.id]}
                            />
                            <Theme preset={myPreset}>
                              <CustomTextTooltip
                                size="s"
                                className={cx('DragAccessModal__nameUser')}
                                text={item.name}
                                offsetHeight={28}
                                lineClamp={1}
                              />
                            </Theme>
                          </div>
                        </div>
                      )}
                    </Draggable>
                  ))}
                </div>
                {provided.placeholder}
              </div>
            )}
          </Droppable>
          <Droppable droppableId={DroppableUserEnum.ALL_USER}>
            {(provided) => (
              <div className={cx('DragAccessModal__columnMobile1')}>
                {isMobile && (
                  <div className={cx('DragAccessModal__titleDivAll')}>
                    <Text
                      size="s"
                      view="secondary"
                      className={cx('DragAccessModal__title')}
                    >
                      Все модели
                    </Text>
                  </div>
                )}
                <div
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  className={cx('DragAccessModal__providContainer')}
                >
                  {allModels.map((item, index) => (
                    <Draggable
                      key={item.id}
                      draggableId={item.id}
                      index={index}
                    >
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                        >
                          <div
                            className={cx('DragAccessModal__containerUser')}
                            key={item.id}
                          >
                            <IconDraggable
                              className={cx('DragAccessModal__draggableIcon')}
                              {...provided.dragHandleProps}
                            />
                            <Checkbox
                              className={cx('DragAccessModal__checkbox')}
                              view="primary"
                              onChange={() => handleCheckedAllUser(item)}
                              checked={!!checkedAllUser[item.id]}
                            />
                            <Theme preset={myPreset}>
                              <CustomTextTooltip
                                size="s"
                                className={cx('DragAccessModal__nameUser')}
                                text={item.name}
                                offsetHeight={28}
                                lineClamp={1}
                              />
                            </Theme>
                          </div>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              </div>
            )}
          </Droppable>
        </div>
      </div>
    </DragDropContext>
  );
};

export default DragAccessModal;
